import styled from 'styled-components';
import MEDIA from 'helpers/mediaTemplates';

export const Container = styled.nav`
  position: absolute;
  right: 65px;
  top: 65px;
  display: ${({ open }) => (open ? 'inline-block' : 'none')};

  ul {
    display: flex;
    list-style: none;
    padding: 0;

    li {
      text-transform: uppercase;
      // font-size: 1.3rem;

      & + li {
        margin-left: 2rem;
      }
    }
  }

  // ${MEDIA.PHONE`
  //   display: ${({ open }) => (open ? 'inline-block' : 'none')};
  //   height: 100vh;
  //   background-color: rgba(255, 255, 255, 0.94);
  //   padding-top: 5rem;
  //   width: 100%;
  //   margin: 0 auto;
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  // `}
`;
